import { useQueryClient } from '@tanstack/react-query'
import { useCallback, useEffect, useRef } from 'react'
import { SCHEDULE_QUERY_KEYS } from '~/queries/scheduleQueries'

import type { ScheduleId } from '@mangovoice/schedule'

export const useScheduleDetailCacheLifecycle = (scheduleId: ScheduleId) => {
  const queryClient = useQueryClient()
  const wasDeleted = useRef(false)

  const invalidateScheduleLists = useCallback(
    () =>
      queryClient.invalidateQueries({
        queryKey: SCHEDULE_QUERY_KEYS.lists(),
      }),
    [queryClient],
  )

  const markScheduleDeleted = useCallback(() => {
    wasDeleted.current = true
  }, [])

  useEffect(
    () => () => {
      if (!wasDeleted.current || !scheduleId) return

      queueMicrotask(() => {
        queryClient.removeQueries({
          queryKey: SCHEDULE_QUERY_KEYS.detail(scheduleId),
        })
      })
    },
    [queryClient, scheduleId],
  )

  return { invalidateScheduleLists, markScheduleDeleted }
}
